import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Alert, Button, TextInput, Label, Spinner } from 'flowbite-react';
import { api } from '../api';
import { useToast } from '../components/ToastProvider';

export default function Settings() {
  const { appUuid } = useParams();
  const { addToast } = useToast();
  const [app, setApp] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ bot_token: '', bot_username: '' });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      setError('');
      try {
        const data = await api.get(`/app-dashboard?app_uuid=${encodeURIComponent(appUuid)}`);
        setApp(data.app);
        setForm({ bot_token: data.app?.bot_token || '', bot_username: data.app?.bot_username || '' });
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [appUuid]);

  const save = async () => {
    setSaving(true);
    setError('');
    try {
      await api.put(`/apps/${appUuid}`, { bot_token: form.bot_token, bot_username: form.bot_username });
      addToast({ type: 'success', message: 'Настройки сохранены' });
    } catch (e) {
      setError(e.message);
      addToast({ type: 'error', message: 'Не удалось сохранить' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="grid gap-4 max-w-2xl">
      <Card>
        <h2 className="text-lg font-semibold">Настройки приложения</h2>
        {error && <Alert color="failure" className="mt-2">{error}</Alert>}
        {loading && <div className="text-sm text-gray-500">Загрузка...</div>}
        {app && (
          <div className="grid gap-4 mt-2">
            <div>
              <Label value="Bot token" />
              <TextInput value={form.bot_token} onChange={e => setForm({ ...form, bot_token: e.target.value })} placeholder="12345:ABC..." />
            </div>
            <div>
              <Label value="Bot username" />
              <TextInput value={form.bot_username} onChange={e => setForm({ ...form, bot_username: e.target.value })} placeholder="mybot" />
            </div>
            <div className="text-sm text-gray-500">
              WebApp URL: <span className="font-mono break-all">{app.webapp_url || 'не задан'}</span>
            </div>
            <div className="flex gap-2">
              <Button color="blue" onClick={save} disabled={saving}>{saving ? (<span className="inline-flex items-center gap-2"><Spinner size="sm" /> Сохранение...</span>) : 'Сохранить'}</Button>
            </div>
          </div>
        )}
      </Card>
    </div>
  );
}